export const EVENT_INIT_FORM = 'INIT_FORM';
export const EVENT_UPDATED_SCHOOL = 'UPDATED_SCHOOL';
export const EVENT_UPDATED_PERSON = 'UPDATED_PERSON';
export const EVENT_UPDATED_TOOL = 'UPDATED_TOOL';
export const EVENT_UPDATED_DEPARTMENT = 'UPDATED_DEPARTMENT';
export const EVENT_UPDATED_GRADE = 'UPDATED_GRADE';
export const EVENT_UPDATED_JOB_TITLE = 'UPDATED_JOB_TITLE';
